<script lang="ts">
  import { onMount } from 'svelte';
  import { i18n } from '../util/i18n/i18n';
  import { trackEvent } from '../util/snowplow';

  onMount(() => {
    trackEvent({ action: 'state:empty-poll' });
  });
</script>

<article>
  <!-- svelte-ignore a11y-autofocus -->
  <h2 autofocus tabindex="-1">{i18n('no-poll.heading')}</h2>
  <p>{i18n('no-poll.text')}</p>
  <a href="https://delta.nrk.no">delta.nrk.no</a>
</article>

<style>
  article {
    text-align: center;
    max-width: 30rem;
  }
  a {
    display: inline;
    text-decoration: underline;
  }
</style>
